module.exports = __webpack_public_path__ + "img/pp_41.df5a82ff.png";